export const initialState = () => ({
  comboUuidEditing: false,
  comboAlreadyFetchEditing: false,
  comboName: "",
  comboCommercialName: "",
  comboCategoriesOptions: [],
  comboCategorySelected: "",
  comboMovementsOptions: [],
  comboMovementSelected: "",
  comboScore: null,
  comboPhysicalPerson: false,
  comboLegalPerson: false,
  comboActive: false,
  comboRecommended: false,
  comboShouldBeDisplayed: false,
  comboIcon: [],
  comboIconPreview: {
    url: "",
    icon: ""
  },
  comboCreatedThrough: "",

  comboPlanOptions: [],
  comboPlansSelecteds: [],
  comboPlansOptionsAlreadySelecteds: [],

  comboCampaignOptions: [],
  comboCampaignSelecteds: [],

  comboCoverageOptions: [],

  comboCoverageStateOptions: [],
  comboCoverageStatesSelecteds: [],

  comboCoverageCityStateOptions: [],
  comboCoverageCityStateSelected: "",
  comboCoverageCityOptions: [],
  comboCoverageCitySelecteds: [],

  comboCoverageDddOptions: [],
  comboCoverageDddsSelecteds: [],

  comboAccessChainOptions: [],
  comboAccessChainsSelecteds: [],

  comboAccessPosOptions: [],
  comboAccessPosSelecteds: [],
  
  comboDiscountOptions: [],
  comboDiscountTypes: {},

  comboDiscountPaymentOptions: [],
  comboDiscountPaymentSelecteds: [],

  comboDiscountShippingOptions: [],
  comboDiscountShippingSelecteds: [],

  comboAccessOptions: [],
})
